let PageData = {
    answered_questions: []
}

export const setAnsweredQuestions = (answered_questions) => {
    PageData.answered_questions = answered_questions
}

export const getAnsweredQuestions = (answered_questions) => {
    return PageData.answered_questions
}

export const ORDER_KEY = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
const YEARS = new Array(100).fill().map((v, i) => ({ value: i + 1, text: `${i + 1}年`}))
export const getQuestions = () => [
    {
        title: '积分落户前提',
        questions: [
            '1、您是否持有本市有效居住证？',
            '2、您是否在本市行政区域内按国家和省、市相关规定连续缴纳城镇职工基本养老保险和城镇职工基本医疗保险５年及以上？',
            '3、您是否满足无刑事犯罪记录及未参加国家禁止的组织或活动？',
        ],
        answers: [
            {
                content: '全部都是',
                points: 0,
                checked: false
            },
            {
                content: '部分或全部为否',
                points: 0,
                checked: false,
                result: '不具备积分落户条件'
            }
        ]
    },
    {
        title: '稳定就业指标',
        questions: [
            '您在本市行政区域内按国家和省、市相关规定参加城镇职工基本养老保险满多少年？'
        ],
        answers: [
            {
                content: '＜6个月',
                checked: false,
                points: 0
            },
            {
                content: '≥6个月',
                checked: false,
                points: 5,
            },
            {
                content: '≥12个月',
                checked: false,
                input: true,
                input_val: 1,
                unit: '年',
                points: (val) => val * 10
            }
        ]
    },
    {
        title: '稳定就业指标',
        questions: [
            '您在本市行政区域内按国家和省、市相关规定参加城镇职工基本医疗保险满多少年？'
        ],
        answers: [
            {
                content: '＜6个月',
                checked: false,
                points: 0
            },
            {
                content: '≥6个月',
                checked: false,
                points: 5,
            },
            {
                content: '≥12个月',
                checked: false,
                input: true,
                input_val: 1,
                unit: '年',
                points: (val) => val * 10
            }
        ]
    },
    {
        title: '稳定就业指标',
        questions: [
            '最近连续三年缴纳养老保险费基数高于四川省上年度职工社会平均工资多少倍?'
        ],
        answers: [
            {
                content: '2倍或低于2.5倍(含)',
                checked: false,
                points: 10
            },
            {
                content: '高于2.5倍低于3倍(含)',
                checked: false,
                points: 20
            }
        ]
    },
    {
        title: '居住引导指标',
        questions: [
            '您在成都市是否有合法稳定的住所?'
        ],
        answers: [
            {
                content: '有',
                checked: false,
                sub_question: {
                    questions: ['您在成都的连续居住年限为'],
                    select: true,
                    selected: -1,
                    label: '连续居住年限',
                    range: YEARS,
                    unit: '年',
                    points: (val) => 5 * val
                }
            },
            {
                content: '没有',
                checked: false,
                points: 0
            }
        ]
    },
    {
        title: '就业引导指标',
        questions: [
            '您的居住区域是否在以下区域范围'
        ],
        answers: [
            {
                content: '龙泉驿区、青白江区、新都区、温江区、双流区、郫都区、新津区',
                checked: false,
                sub_question: {
                    questions: ['您在龙泉驿区、青白江区、新都区、温江区、双流区、郫都区、新津区居住年限为'],
                    select: true,
                    selected: -1,
                    label: '居住年限',
                    range: YEARS,
                    points: (val) => Math.min(10, 2 * val)
                }
            },
            {
                content: '简阳市、都江堰市、彭州市、邛崃市、崇州市、金堂县、大邑县、蒲江县',
                checked: false,
                sub_question: {
                    questions: ['您在简阳市、都江堰市、彭州市、邛崃市、崇州市、金堂县、大邑县、蒲江县居住年限为'],
                    select: true,
                    selected: -1,
                    label: '居住年限',
                    range: YEARS,
                    points: (val) => Math.min(20, 4 * val)
                }
            },
            {
                content: '成都东部新区',
                checked: false,
                sub_question: {
                    questions: ['您在成都东部新区居住年限为'],
                    select: true,
                    selected: -1,
                    label: '居住年限',
                    range: YEARS,
                    points: (val) => Math.min(30, 6 * val)
                }
            },
            {
                content: '以上都不在',
                checked: false,
                points: 0
            }
        ]
    },
    {
        title: '就业引导指标',
        questions: [
            '从2018年1月1日起至申请日上月底期间，您的就业所在地属于66个产业功能区?'
        ],
        answers: [
            {
                content: '属于',
                checked: false,
                sub_question: {
                    questions: ['您在成都的连续就业年限为'],
                    select: true,
                    selected: -1,
                    label: '连续就业年限',
                    range: YEARS,
                    points: (val) => 10 * val
                }
            },
            {
                content: '不属于',
                checked: false,
                points: 0
            }
        ]
    },
    {
        title: '就业引导指标',
        questions: [
            '您的就业区域是否在以下区域范围'
        ],
        answers: [
            {
                content: '天府国际空港新城、简州新城、淮州新城等东进区域',
                checked: false,
                sub_question: {
                    questions: ['您在天府国际空港新城、简州新城、淮州新城等东进区域就业年限为'],
                    select: true,
                    selected: -1,
                    label: '就业年限',
                    range: YEARS,
                    points: (val) => Math.min(20, 4 * val)
                }
            },
            {
                content: '成都科学城、天府总部商务区、天府国际生物城、天府智能制造产业园等南拓区域',
                checked: false,
                sub_question: {
                    questions: ['您在成都科学城、天府总部商务区、天府国际生物城、天府智能制造产业园等南拓区域就业年限为'],
                    select: true,
                    selected: -1,
                    label: '就业年限',
                    range: YEARS,
                    points: (val) => Math.min(20, 4 * val)
                }
            },
            {
                content: '欧洲产业城、新都智慧物流产业园等北改区域和中德(蒲江)中小企业合作区、彭州天府中药城等西控区域',
                checked: false,
                sub_question: {
                    questions: ['您在成都科学城、天府总部商务区、天府国际生物城、天府智能制造产业园等南拓区域就业年限为'],
                    select: true,
                    selected: -1,
                    label: '就业年限',
                    range: YEARS,
                    points: (val) => Math.min(10, 2 * val)
                }
            },
            {
                content: '以上都不在',
                checked: false,
                points: 0
            }
        ]
    },
    {
        title: '入户区域引导指标',
        questions: [
            '请选择您想要申请入户的区域'
        ],
        answers: [
            {
                content: '龙泉驿区、青白江区、新都区、温江区、双流区、郫都区、新津区',
                checked: false,
                points: 10
            },
            {
                content: '远郊新城',
                checked: false,
                points: 20
            },
            {
                content: '东部新区',
                checked: false,
                points: 30
            }
        ]
    },
    {
        title: '技术技能指标',
        questions: [
            '您是否属于《成都市人才开发指引》范围'
        ],
        answers: [
            {
                content: '属于',
                checked: false,
                sub_question: {
                    questions: ['人才紧缺综合指数'],
                    radio: true,
                    answers: [
                        {
                            content: '三颗星',
                            checked: false,
                            points: 20
                        },
                        {
                            content: '两颗星',
                            checked: false,
                            points: 15
                        },
                        {
                            content: '一颗星',
                            checked: false,
                            points: 10
                        }
                    ]
                }
            },
            {
                content: '不属于',
                checked: false,
                points: 0
            }
        ]
    },
    {
        title: '技术技能指标',
        type: 'radio',
        questions: [
            '您是否获得过以下类型的表彰？'
        ],
        items: [
            {
                questions: [
                    '您是否具备职称'
                ],
                answers: [
                    {
                        content: '高级职称',
                        checked: false,
                        points: 40,
                        value: 0,
                    },
                    {
                        content: '中级职称',
                        checked: false,
                        points: 30,
                        value: 1
                    },
                    {
                        content: '初级职称',
                        checked: false,
                        points: 20,
                        value: 2
                    }
                ]
            },
            {
                questions: [
                    '您是否具有高级技师或技师资格？'
                ],
                answers: [
                    {
                        content: '高级技师',
                        checked: false,
                        value: 3,
                        points: 40
                    },
                    {
                        content: '技师资格',
                        checked: false,
                        value: 4,
                        points: 30
                    }
                ]
            },
            {
                questions: [
                    '你是否具备以下资格'
                ],
                answers: [
                    {
                        content: '高级工',
                        checked: false,
                        value: 5,
                        points: 30
                    },
                    {
                        content: '中级工',
                        checked: false,
                        value: 6,
                        points: 20
                    },
                    {
                        content: '初级工',
                        checked: false,
                        value: 7,
                        points: 10
                    }
                ]
            }
        ]
    },
    {
        type: 'multi-radio',
        title: '个人贡献指标',
        questions: [
            '你是否获得过以下类型的表彰？'
        ],
        items: [
            {
                questions: [
                    '创新创业（近五年内）'
                ],
                answers: [
                    {
                        content: '国家级',
                        checked: false,
                        points: 25
                    },
                    {
                        content: '四川省',
                        checked: false,
                        points: 20
                    },
                    {
                        content: '成都市',
                        checked: false,
                        points: 15
                    }
                ]
            },
            {
                questions: [
                    '劳动模范（含享受劳模待遇的）'
                ],
                answers: [
                    {
                        content: '国家级',
                        checked: false,
                        points: 25
                    },
                    {
                        content: '四川省',
                        checked: false,
                        points: 20
                    },
                    {
                        content: '成都市',
                        checked: false,
                        points: 15
                    }
                ]
            },
            {
                questions: [
                    '道德模范'
                ],
                answers: [
                    {
                        content: '国家级',
                        checked: false,
                        points: 25
                    },
                    {
                        content: '四川省',
                        checked: false,
                        points: 20
                    },
                    {
                        content: '成都市',
                        checked: false,
                        points: 15
                    }
                ]
            },
            {
                questions: [
                    '见义勇为模范'
                ],
                answers: [
                    {
                        content: '国家级',
                        checked: false,
                        points: 25
                    },
                    {
                        content: '四川省',
                        checked: false,
                        points: 20
                    },
                    {
                        content: '成都市',
                        checked: false,
                        points: 15
                    }
                ]
            },
            {
                questions: [
                    '工匠'
                ],
                answers: [
                    {
                        content: '国家级',
                        checked: false,
                        points: 25
                    },
                    {
                        content: '四川省',
                        checked: false,
                        points: 20
                    },
                    {
                        content: '成都市',
                        checked: false,
                        points: 15
                    }
                ]
            },
        ]
    },
    {
        title: '个人贡献指标',
        type: 'inputs',
        questions: [
            '您是否参与过以下类型的社会服务（多选）'
        ],
        items: [
            {
                question: '申请日上月底上溯计算12个月内志愿者服务',
                inputs: [
                    {
                        placeholder: '请填写志愿者服务时间',
                        type: 'number',
                        unit: '小时',
                        value: ''
                    }
                ],
                points: (vals) => {
                    const val = vals[0]
                    if (val < 25) {
                        return 0
                    }
                    return Math.min(10, parseInt((val - 25) / 2) + 2)
                }
            },
            {
                question: '近3年内慈善捐赠',
                inputs: [
                    {
                        placeholder: '请填写慈善捐款金额',
                        type: 'number',
                        value: '',
                        unit: '万元'
                    }
                ],
                points: ([val]) => Math.min(10, val * 10 * 2)
            },
            {
                question: '申请日上月底上溯计算12个月内无偿献血',
                inputs: [
                    {
                        placeholder: '请填写捐赠全血量',
                        type: 'number',
                        unit: '毫升',
                        value: '',
                    },
                    {
                        placeholder: '请填写捐赠血小板量',
                        type: 'number',
                        value: '',
                        unit: '治疗量'
                    }
                ],
                points: ([val1, val2]) => {
                    let points = 0
                    if (val1 >= 200) {
                        points += 2 + parseInt((val1 - 200) / 100)
                    }
                    if (val2 >= 1) {
                        points += 2 + parseInt((val2 - 1) / 0.5) * 1
                    }
                    return Math.min(points, 10)
                }
            },
        ],
    },
    {
        title: '个人贡献指标',
        questions: [
            '您是否是退役军人，并获得过以下功勋？'
        ],
        answers: [
            {
                content: '一等功',
                checked: false,
                points: 25
            },
            {
                content: '二等功',
                checked: false,
                points: 20
            },
            {
                content: '三等功',
                checked: false,
                points: 15
            },
            {
                content: '否',
                checked: true,
                points: 0
            }
        ]
    },
    {
        title: '年龄指标',
        questions: [
            '您的年龄范围是？'
        ],
        answers: [
            {
                content: '≤35岁',
                checked: false,
                points: 50
            },
            {
                content: '36-45岁',
                checked: false,
                points: 40
            },
            {
                content: '＞45岁',
                checked: false,
                points: 0
            }
        ]
    },
    {
        title: '个人不良信用记录指标',
        questions: [
            '您是否存在以下类型的不良记录（多选）'
        ],
        checkbox: true,
        answers: [
            {
                content: '个人信用',
                checked: false,
                input: true,
                input_val: 1,
                unit: '条',
                points: (val) => -10 * val
            },
            {
                content: '市场监督',
                checked: false,
                input: true,
                input_val: 1,
                unit: '条',
                points: (val) => -10 * val
            },
            {
                content: '税务方面',
                checked: false,
                input: true,
                input_val: 1,
                unit: '条',
                points: (val) => -10 * val
            },
            {
                content: '不存在',
                points: 0,
                checked: true,
                singled: true
            }
        ]
    },
    {
        title: '个人违法犯罪记录指标',
        checkbox: true,
        questions: [
            '您是否存在以下类型的违法犯罪记录（多选）'
        ],
        answers: [
            {
                content: '因刑事犯罪被处罚',
                checked: false,
                points: -100
            },
            {
                content: '参加过国家禁止的组织或活动被处罚',
                checked: false,
                points: -100
            },
            {
                content: '被强制戒毒',
                checked: false,
                input: true,
                input_val: 1,
                unit: '次',
                points: (val) => -50 * val
            },
            {
                content: '被行政执法机关处以行政拘留',
                checked: false,
                input: true,
                input_val: 1,
                unit: '次',
                points: (val) => -20 * val
            },
            {
                content: '不存在',
                checked: true,
                points: 0,
                singled: true
            }
        ]
    }
]

export const getPoints = (questions) => {
    const total_points = questions.reduce((points, item) => {
        if (item.select) {
            const val = item.selected > -1 ? item.range[item.selected].value : 0
            console.error(item.title, val, item.points(val))
            const point = item.points(val)
            item.score = point
            item.answer = item.selected > -1 ? item.range[item.selected].text : ''
            points += point
        } else if (item.type === 'radio') {
            let item_score = 0
            item.items.some(({ answers }) => {
                return answers.some((answer) => {
                    if (answer.checked) {
                        points += answer.points
                        item_score += answer.points
                        return true
                    }
                })
            })
            item.score = item_score
        } else if (item.type === 'multi-radio') {
            let item_score = 0
            item.items.forEach(({ answers }) => {
                return answers.some((answer) => {
                    if (answer.checked) {
                        points += answer.points
                        item_score += answer.points
                        return true
                    }
                })
            })
            item.score = item_score
        } else if (item.type === 'inputs') {
            let item_score = 0
            item.items.forEach((answer) => {
                const values = answer.inputs.map(({ value }) => value)
                console.log(answer, 'values', values)
                const score = answer.points(values)
                points += score
                item_score += score
            })
            item.score = item_score
        } else {
            const answer_arr = []
            const item_point = item.answers.reduce((item_points, opt, i) => {
                opt.order = ORDER_KEY[i]
                if (opt.checked && opt.points) {
                    let point = opt.points || 0
                    let input_val = ''
                    if (typeof opt.points === 'function') {
                        let val = 0
                        if (opt.input) {
                            val = opt.input_val || 0
                        }
                        point = opt.points(val)
                        input_val = val ? (val + opt.unit) : ''
                        console.error(item.title, val, opt.points, point)
                    }
                    answer_arr.push([opt.order, input_val].filter(v => v).join('&nbsp;&nbsp;'))
                    item_points += point
                }
                return item_points
            }, 0)
            item.answer = answer_arr.join('；')
            item.score = item_point
            points += item_point
        }
        return points
    }, 0)
    return total_points >= 0 ? total_points : 0
}